import { render, staticRenderFns } from "./addProduct.vue?vue&type=template&id=1f9cf18f&scoped=true"
import script from "./addProduct.vue?vue&type=script&lang=ts&name=addProduct"
export * from "./addProduct.vue?vue&type=script&lang=ts&name=addProduct"
import style0 from "./addProduct.vue?vue&type=style&index=0&id=1f9cf18f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9cf18f",
  null
  
)

export default component.exports